import dayjs, { Dayjs } from "utils/dayjs";

import { Guid } from "@/types";

import { toDateWithoutTimezone } from "utils/utils";
import { AssetOrigin } from "./Asset";

export interface IEvaluationParametersPeriodDto {
    id: Guid
    assetOrigin: AssetOrigin
    validFrom?: string | null
    validTo?: string | null
}

export interface ICreateEvaluationParametersPeriodDto {
    assetOrigin: AssetOrigin
    validFrom: string
}

export default class EvaluationParametersPeriod {
    id: Guid
    assetOrigin: AssetOrigin
    validFrom?: Dayjs
    validTo?: Dayjs

    constructor(dto: IEvaluationParametersPeriodDto) {
        this.id = dto.id
        this.assetOrigin = dto.assetOrigin
        this.validFrom = dto.validFrom ? dayjs(dto.validFrom, "YYYY-MM-DD") : undefined
        this.validTo = dto.validTo ? dayjs(dto.validTo, "YYYY-MM-DD") : undefined
    }

    toDto(): IEvaluationParametersPeriodDto {
        return {
            id: this.id,
            assetOrigin: this.assetOrigin,
            validFrom: this.validFrom ? toDateWithoutTimezone(this.validFrom) : null,
            validTo: this.validTo ? toDateWithoutTimezone(this.validTo) : null,
        }
    }
}
